<template>
  <div class="c-results">
    <search-filter 
      v-bind:categories="categories" 
      v-bind:searchTerm.sync="searchTerm" 
      v-on:formSearch="submitSearch">
    </search-filter>
    <div class="grid-container" v-if="!initialLoad">
      <div class="grid-x grid-margin-x o-columns__two o-columns__two--alt-1">
        <div class="cell" aria-live="polite">
          <p class="c-summary">You searched for "{{searchTerm}}", we have found {{totalResultsCount}} results.</p>
        </div>
        <div class="cell">
          <search-tablist>
            <search-tab name="searchResultsPages" panelSuffix="Panel" tabSuffix="Tab" v-bind:isActive="true" title="Pages">
              <search-listing 
                item-component="SearchItemPage" 
                v-bind:resultsListing="pageResults"
                v-if="hasPageResults">
              </search-listing>
              <search-paging 
                searchType="pages"
                v-bind:currentPage="pageCurrentPage" 
                v-bind:totalPages="pageTotalPages" 
                v-on:getResults="getSearchResults"
                v-if="hasPageResults">
              </search-paging>
              <search-error v-if="pageResultsError"></search-error>
              <search-no-results 
                searchType="pages"
                v-bind:searchTerm="searchTerm"
                v-if="!hasPageResults && !pageResultsError">
              </search-no-results>              
            </search-tab>
            <search-tab name="searchResultsDocuments" panelSuffix="Panel" tabSuffix="Tab" v-bind:isActive="false" title="Documents">
              <search-listing
                item-component="SearchItemDoc"
                v-bind:resultsListing="docResults"
                v-if="hasDocResults">
              </search-listing>
              <search-paging 
                searchType="documents"
                v-bind:currentPage="docCurrentPage" 
                v-bind:totalPages="docTotalPages" 
                v-on:getResults="getSearchResults"
                v-if="hasDocResults">
              </search-paging>
              <search-error v-if="docResultsError"></search-error>              
              <search-no-results 
                searchType="documents"
                v-bind:searchTerm="searchTerm"
                v-if="!hasDocResults && !docResultsError">
              </search-no-results>              
            </search-tab>
          </search-tablist>          
        </div>
      </div>
    </div>
    <search-loading v-if="loading"></search-loading>
  </div>
</template>

<script>
import "url-search-params-polyfill";
import axios from "axios";
import endpoints from "Globals/mando.endpoints";
import SearchError from "./SearchError.vue";
import SearchFilter from "./SearchFilter.vue";
import SearchListing from "./SearchListing.vue";
import SearchLoading from "./SearchLoading.vue";
import SearchNoResults from "./SearchNoResults.vue";
import SearchPaging from "./SearchPaging.vue";
import SearchTab from "./SearchTab.vue";
import SearchTablist from "./SearchTablist.vue";

export default {
  name: "SearchResults",
  components: {
    SearchError,
    SearchFilter,
    SearchListing,
    SearchLoading,
    SearchNoResults,
    SearchPaging,
    SearchTab,
    SearchTablist
  },
  props: {
    categories: {
      required: true,
      type: Array
    },
    componentId: {
      required: true,
      type: String
    },
    siteId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      delay: 500,
      docCurrentPage: 1,
      docResults: [],
      docResultsCount: 0,
      docResultsError: false,
      docTotalPages: 0,
      initialLoad: true,
      loading: true,
      pageCurrentPage: 1,
      pageResults: [],
      pageResultsCount: 0,
      pageResultsError: false,
      pageTotalPages: 0,
      searchCatergories: "",
      searchTerm: "",
      timer: null
    };
  },
  computed: {
    hasDocResults() {
      return (this.docResults.length > 0);
    },
    hasPageResults() {
      return (this.pageResults.length > 0);
    },
    totalResultsCount() {
      return (this.docResultsCount + this.pageResultsCount);
    }
  },
  mounted() {
    this.parseQueryString()
  },
  methods: {
    getSearchResults(page, searchType) {
      this.loading = true;

      axios
        .get(`${endpoints(this.lookupEndpoints(searchType))}?searchTerm=${this.searchTerm}${this.searchCatergories}&page=${page}&componentId=${this.componentId}&siteId=${this.siteId}`)
        .then(this.getSearchResultsSuccess.bind(this, searchType))
        .catch(this.getSearchResultsFail.bind(this, searchType))
        .finally(this.getSearchResultsFinally);
    },
    getSearchResultsSuccess(searchType, r) {
      if (r.status === 200) {
        if (searchType === "documents") {
          this.docResults = r.data.results;
          this.docCurrentPage = r.data.pageNumber;
          this.docTotalPages = r.data.totalPages;
          this.docResultsCount = r.data.totalResults;
        }
        else if (searchType === "pages") {
          this.pageResults = r.data.results;
          this.pageCurrentPage = r.data.pageNumber;
          this.pageTotalPages = r.data.totalPages;
          this.pageResultsCount = r.data.totalResults;
        }
      }
      else {
        this.getSearchResultsFail(searchType);
      }
    },
    getSearchResultsFail(searchType) {
      if (searchType === "documents") {
        this.docResultsError = true;
      }
      else if (searchType === "pages") {
        this.pageResultsError = true;
      }
    },
    getSearchResultsFinally() {
      this.timer = setTimeout(() => {
        this.initialLoad = false;
        this.loading = false;
        this.timer = null;
      }, this.delay);
    },
    lookupEndpoints(key) {
      const searchType = {
        documents: "getSearchResultsDoc",
        pages: "getSearchResultsPage"
      }
      return searchType[key];
    },
    parseQueryString() {
      const queryString = new URLSearchParams(window.location.search);      

      if (queryString.has("searchTerm")) {
        this.searchTerm = queryString.get("searchTerm");
        this.getSearchResults(1, "documents");
        this.getSearchResults(1, "pages");
      }
      else {
        this.loading = false;
      }
    },
    submitSearch(searchTerm, searchCatergories) {
      this.searchCatergories = searchCatergories.map(el => `&categories=${el}`).join('');
      this.searchTerm = searchTerm;
      this.getSearchResults(1, "documents");
      this.getSearchResults(1, "pages");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/searches/results/SearchResults.vue